// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "48cac69";
